import { render, staticRenderFns } from "./BatchManagement.vue?vue&type=template&id=76a80e10&scoped=true"
import script from "./BatchManagement.vue?vue&type=script&lang=js"
export * from "./BatchManagement.vue?vue&type=script&lang=js"
import style0 from "./BatchManagement.vue?vue&type=style&index=0&id=76a80e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a80e10",
  null
  
)

export default component.exports